import { fork } from 'redux-saga/effects'

import * as watchers from './settings-watchers'

export default [
  fork(watchers.watchSettingsUpdate),
  fork(watchers.watchPartnerUpdate),
  fork(watchers.watchPortalUserSearch),
  fork(watchers.watchPartnerSearch),
  fork(watchers.watchSettingsSuccess),
]



/** WEBPACK FOOTER **
 ** ./src/sagas/settings/index.js
 **/